import { render, staticRenderFns } from "./roster_stats_report.vue?vue&type=template&id=4bffaf72&"
import script from "./roster_stats_report.vue?vue&type=script&lang=js&"
export * from "./roster_stats_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports